export default {
    meta: {
        title: '鱼你在一起-机会点详情',
        url: '/fishtogether/chancepointlist',
        urlName: '鱼你机会点'
    }
};
